import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=a795d2c2&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=ts"
export * from "./TagList.vue?vue&type=script&lang=ts"
import style0 from "./TagList.vue?vue&type=style&index=0&id=a795d2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a795d2c2",
  null
  
)

export default component.exports